export var dotProduct = function (vectorA, vectorB) {
    return vectorA.reduce(function (acc, cur, idx) { return acc + cur * vectorB[idx]; }, 0);
};
var euclideanLength = function (vector) {
    return Math.sqrt(vector.reduce(function (acc, cur) { return acc + Math.pow(cur, 2); }, 0));
};
export var cosineSimilarity = function (vectorA, vectorB) {
    return (dotProduct(vectorA, vectorB) /
        (euclideanLength(vectorA) * euclideanLength(vectorB)));
};
export var sigmoid = function (z) {
    return 1 / (1 + Math.exp(-z));
};
//# sourceMappingURL=math.js.map